export default __webpack_public_path__ + "static/sx-aafb13f61b6688f41a14c976d908b855.svg";